import { fitTitlePx, fitDescriptionPx, measureTitlePx, measureDescriptionPx } from './seoPixelHelper';

export const SERVICES_META = {
  'kloakspuling': {
    title: 'Kloakspuling i Sommersted & omegn | Jan Nørgaard',
    description: 'Professionel kloakspuling og rensning af stoppede kloakker og afløb. Over 20 års erfaring som autoriseret kloakmester i Sommersted og omegn.',
  },
  'draen-etablering-reparation': {
    title: 'Dræn & Omfangsdræn | Entreprenør Jan Nørgaard',
    description: 'Professionel etablering og reparation af dræn omkring hus og fundament. Undgå fugtskader i kælderen med autoriseret kloakmester Jan Nørgaard.',
  },
  'stoebearbejde': {
    title: 'Støbearbejde & Fundamenter | Jan Nørgaard',
    description: 'Professionelt støbearbejde og støbning af fundamenter, sokler og betongulve til nybyg og tilbygninger. Over 20 års erfaring. Få et tilbud.',
  },
  'belaegning': {
    title: 'Belægning & Flisearbejde | Jan Nørgaard',
    description: 'Kvalitetsbelægning af indkørsler, terrasser og gangstier. Korrekt bærelag sikrer holdbarhed og modvirker kørespor. Få et uforpligtende tilbud.',
  },
  'kloakmester': {
    title: 'Autoriseret Kloakmester | Jan Nørgaard ApS',
    description: 'Autoriseret kloakmester Jan Nørgaard ApS løser alle kloakopgaver. Nyanlæg, renovering, fejlfinding og reparation. Få et uforpligtende tilbud.',
  },
  'tv-inspektion': {
    title: 'TV-inspektion af kloakrør | Jan Nørgaard',
    description: 'Effektiv TV-inspektion af kloak med kamera. Vi lokaliserer brud, rødder og rotteangreb hurtigt og præcist uden opgravning. Få fuld rapport.',
  },
  'kloakseparering': {
    title: 'Kloakseparering | Entreprenør Jan Nørgaard',
    description: 'Autoriseret kloakseparering af regn- og spildevand. Vi hjælper dig med at overholde kommunale påbud og undgå oversvømmelse. Få et tilbud.',
  },
  'omfangsdraen': {
    title: 'Omfangsdræn mod fugt i kælderen | Jan Nørgaard',
    description: 'Etablering af omfangsdræn og udvendig sokkelisolering. Beskyt kælderen mod fugt og skimmelsvamp. Autoriseret kloakmester i Sommersted og omegn.',
  },
  'minirenseanlaeg': {
    title: 'Minirenseanlæg | Etablering & Tilslutning',
    description: 'Godkendt biologisk minirenseanlæg til spildevandsrensning i det åbne land. Vi håndterer ansøgning, udgravning og installation. Få et tilbud.',
  },
  'nedsivningsanlaeg': {
    title: 'Nedsivningsanlæg | Etablering af kloakmester',
    description: 'Professionel etablering af nedsivningsanlæg til spildevand. Vi tager jordbundsprøver, søger tilladelse og graver anlægget. Få et tilbud her.',
  },
  'rottespaerre': {
    title: 'Montering af Rottespærre | Jan Nørgaard',
    description: 'Effektiv sikring mod rotter i kloakken med godkendt rottespærre i rustfrit stål. Montering og årlig service af autoriseret kloakmester.',
  },
  'udgravning-til-byggeri': {
    title: 'Udgravning til byggeri | Jan Nørgaard',
    description: 'Professionel udgravning og opbygning af stabil sandpude til parcelhuse, garager og erhvervsbyggeri. Præcist arbejde med moderne maskiner.',
  },
  'laserafretning': {
    title: 'Laserafretning af underlag | Jan Nørgaard',
    description: 'Millimeterpræcis laserafretning af sand og grus til industrigulve, pladser, haller og ridebaner. Hurtigt og snorlige resultat. Få et tilbud.',
  },
  'udgravning-af-soe': {
    title: 'Udgravning af sø & vildtsø | Jan Nørgaard',
    description: 'Professionel udgravning af søer, vildtsøer og regnvandsbassiner. Vi sikrer de rette skråningsvinkler og tæt bund. Få et uforpligtende tilbud.',
  },
  'pavillon-anlaegsarbejde': {
    title: 'Pavillon & Anlægsarbejde | Jan Nørgaard',
    description: 'Professionelt anlægsarbejde, terrasser og montage af havepavilloner. Vi forvandler dine udendørsarealer til smukke uderum. Få et tilbud i dag.',
  },
  'reparation-etablering-af-ridebaner': {
    title: 'Etablering af Ridebaner | Jan Nørgaard',
    description: 'Etablering og renovering af udendørs og indendørs ridebaner med dræn og laserafretning. Få et optimalt fjedrende underlag. Kontakt os i dag.',
  },
  'mini-vaadomraader': {
    title: 'Mini Vådområder til landbrug | Jan Nørgaard',
    description: 'Etablering af mini-vådområder til effektiv rensning af drænvand fra landbrugsarealer. Vi udfører præcis udgravning og terrænregulering.',
  },
};

/**
 * Returns pixel-verified meta title and description for a service.
 * Guarantees title <= 512px and description <= 970px.
 */
export function getServiceMeta(slug, service = {}) {
  const curated = SERVICES_META[slug];
  
  let candidateTitle = curated?.title || service.meta_title || service.title || 'Ydelse | Jan Nørgaard';
  let candidateDesc = curated?.description || service.meta_description || service.intro || 'Professionelt entreprenør- og kloakarbejde udført af autoriseret kloakmester Jan Nørgaard ApS.';

  // If candidateTitle is too long, use curated or fit it
  if (measureTitlePx(candidateTitle) > 512 && curated?.title) {
    candidateTitle = curated.title;
  }
  const finalTitle = fitTitlePx(candidateTitle, 512);

  // If candidateDesc is too long, use curated or fit it
  if (measureDescriptionPx(candidateDesc) > 970 && curated?.description) {
    candidateDesc = curated.description;
  }
  const finalDesc = fitDescriptionPx(candidateDesc, 970);

  return {
    title: finalTitle,
    description: finalDesc,
  };
}
